import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const GenderFemaleShape = ({
  width = 15,
  height = 21,
  fillColor = 'none'
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 21"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 7.03125C12.5 4.01094 10.0515 1.5625 7.03125 1.5625C4.01094 1.5625 1.5625 4.01094 1.5625 7.03125C1.5625 10.0515 4.01094 12.5 7.03125 12.5C10.0515 12.5 12.5 10.0515 12.5 7.03125ZM14.0625 7.03125C14.0625 10.6504 11.3281 13.6309 7.8125 14.0195V16.6667H9.11459C9.54606 16.6667 9.89584 17.0164 9.89584 17.4479C9.89584 17.8794 9.54606 18.2292 9.11459 18.2292H7.8125V19.5312C7.8125 19.9627 7.46272 20.3125 7.03125 20.3125C6.59978 20.3125 6.25 19.9627 6.25 19.5312V18.2292H4.94791C4.51644 18.2292 4.16666 17.8794 4.16666 17.4479C4.16666 17.0164 4.51644 16.6667 4.94791 16.6667H6.25V14.0195C2.73441 13.6309 0 10.6504 0 7.03125C0 3.148 3.148 0 7.03125 0C10.9145 0 14.0625 3.148 14.0625 7.03125Z"
        fill="black"
      />
    </svg>
  );
};

export default GenderFemaleShape;
